import {useParams} from 'react-router-dom'
import UserFaqVideoMyQuestion from '../../../components/FaqVideo/user-faq-myquestions'
import {ContainerPage} from '../../../components/ui'

const FaqMyQuestionsPage = () => {
  const {consultationId} = useParams()
  return (
    <ContainerPage>
      <UserFaqVideoMyQuestion />
    </ContainerPage>
  )
}
export {FaqMyQuestionsPage}
